import * as React from 'react'
import { Grid } from '@mds/mds-reactjs-library'
import Error from '../components/Error'
import ViewLayout, { classes } from '../components/ViewLayout'
import { ForbiddenAccessIcon } from '../icons'
import type { Customization } from '../types/Customization'

type InvalidRedirectUriProps = {
  customization?: Customization
}

const defaultSolutionName = 'the solution owner'
const getText = ({ customization }: InvalidRedirectUriProps) => (
  <p>
    Configuration Error — Redirect URI is not valid.
    <br />
    Please contact{' '}
    {!!customization?.enrollmentHomeUrl && !!customization?.enrollmentTeamName ? (
      <a href={customization.enrollmentHomeUrl}>{customization.enrollmentTeamName}</a>
    ) : (
      defaultSolutionName
    )}{' '}
    for further information.
  </p>
)

const InvalidRedirectUri = ({ customization }: InvalidRedirectUriProps): JSX.Element => (
  <ViewLayout>
    <section className={classes.wrappingBox}>
      <Grid item span={12}>
        <Error icon={<ForbiddenAccessIcon />} title="Invalid Redirect URL" text={getText({ customization })} />
      </Grid>
    </section>
  </ViewLayout>
)

export default InvalidRedirectUri
